import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { ROUTES } from "../utils/constants";
import { logout } from "../redux/authSlice";
import ThemeToggle from "./ThemeToggle";
import styles from "./EmployeeLayout.module.css";

export default function EmployeeLayout() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useSelector((state) => state.auth);

  const handleLogout = async () => {
    await dispatch(logout()).unwrap();
    navigate(ROUTES.LOGIN, { replace: true });
  };

  const now = new Date();
  const dateStr = now.toLocaleDateString("en-IN", {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
  const timeStr = now.toLocaleTimeString("en-IN", {
    hour: "2-digit",
    minute: "2-digit",
  });

  const userName = user?.email?.split("@")[0] || "User";

  const navItems = [
    { path: ROUTES.EMPLOYEE_DASHBOARD, label: "Dashboard", icon: "📊" },
    { path: ROUTES.EMPLOYEE_DCR, label: "DCR", icon: "📋" },
    { path: ROUTES.EMPLOYEE_DCR_REPORT, label: "DCR Report", icon: "📈" },
  ];

  return (
    <div className={styles.layout}>
      <aside className={styles.sidebar}>
        <div className={styles.sidebarHeader}>
          <p className={styles.sidebarWelcome}>Welcome {userName}</p>
          <span className={styles.dateTime}>{dateStr}</span>
          <span className={styles.dateTime}>{timeStr}</span>
        </div>
        <nav className={styles.nav}>
          {navItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => `${styles.navLink} ${isActive ? styles.active : ""}`}
            >
              <span className={styles.navIcon}>{item.icon}</span>
              <span>{item.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>
      <main className={styles.main}>
        <div className={styles.topBar}>
          <div className={styles.pageTitle}>My Dashboard</div>
          <div className={styles.topBarActions}>
            <ThemeToggle className={styles.headerThemeToggle} />
            <button onClick={handleLogout} className={styles.logoutBtn}>
              Logout
            </button>
          </div>
        </div>
        <div className={styles.outlet}>
          <Outlet />
        </div>
      </main>
    </div>
  );
}
